import {
  FullScreenSuspenseFallback,
  ScreenTooSmall,
  useResetZoomOnOrientationChange,
  useScreenHeight,
  useScreenWidth,
} from "@/lib/main";
import "@/src/assets/styles/fonts.css";
import { Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import routes from "./routes";

export default function App() {
  const { screenHeight } = useScreenHeight();
  const { screenWidth } = useScreenWidth();

  useResetZoomOnOrientationChange();

  const router = createBrowserRouter(routes);

  return (
    <>
      {screenWidth < 320 || screenHeight < 320 ? (
        <ScreenTooSmall />
      ) : (
        <Suspense fallback={<FullScreenSuspenseFallback message="Loading" />}>
          <RouterProvider router={router} />
        </Suspense>
      )}
    </>
  );
}
